module.exports = __webpack_public_path__ + "static/media/ic_accounting.021896ba.svg";